import { GET_HANDYMAN_LIST, LOAD_MORE_HANDYMEN, RESET_HANDYMAN_LIST } from './actions';
import { HandymanViewModel } from '../../configuration/api/apiSchema';

export interface HandymanState {
    isLoading: boolean;
    isLoadingMore: boolean;
    handymanList?: HandymanViewModel[];
    error?: string;
    hasMore: boolean;
    currentPage: number;
}

const initialState: HandymanState = {
    isLoading: false,
    isLoadingMore: false,
    handymanList: undefined,
    error: undefined,
    hasMore: true,
    currentPage: 1
};

export const reducer = (state = initialState, action: any): HandymanState => {
    switch (action.type) {
        case GET_HANDYMAN_LIST.REQUEST:
            return {
                ...state,
                isLoading: true,
                error: undefined
            };
        case GET_HANDYMAN_LIST.SUCCESS:
            return {
                ...state,
                isLoading: false,
                handymanList: action.handymanList,
                hasMore: action.hasMore ?? true,
                currentPage: 1,
                error: undefined
            };
        case GET_HANDYMAN_LIST.FAILURE:
            return {
                ...state,
                isLoading: false,
                error: action.error
            };
        case LOAD_MORE_HANDYMEN.REQUEST:
            return {
                ...state,
                isLoadingMore: true,
                error: undefined
            };
        case LOAD_MORE_HANDYMEN.SUCCESS:
            return {
                ...state,
                isLoadingMore: false,
                handymanList: [...(state.handymanList || []), ...action.handymanList],
                hasMore: action.hasMore,
                currentPage: action.page,
                error: undefined
            };
        case LOAD_MORE_HANDYMEN.FAILURE:
            return {
                ...state,
                isLoadingMore: false,
                error: action.error
            };
        case RESET_HANDYMAN_LIST:
            return {
                ...initialState
            };
        default:
            return state;
    }
};